import { Card, Anchor, Skeleton, Text } from '@mantine/core'

import { useQueryGetInquiryById, useQueryGetStoreDetails } from '@flecto/core/saas'
import { useTranslation } from '@flecto/translations'
import { formatDateString } from '@flecto/utils'

export type CardInquirySummaryProps = {
  inquiryId: number
}

export function CardInquirySummary({ inquiryId }: CardInquirySummaryProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'inquiries' })
  const { data: store } = useQueryGetStoreDetails()
  const { data, isLoading: loading } = useQueryGetInquiryById({ inquiryId })

  const inquiry = data?.inquiry

  const source = {
    url: `https://${store?.domain}.flecto.store`,
    key: t('flecto_store') || '',
  }

  return (
    <Card>
      {loading ? (
        <Skeleton data-testid='loading-title' />
      ) : (
        <Text fw={500} mb='xs'>{t('about-this-request')}</Text>
      )}
      {loading ? (
        <Skeleton data-testid='loading-subtitle' />
      ) : (
        <Text c='dimmed'>
          {t('received-on', {
            replace: {
              date: formatDateString({
                date: inquiry?.created_at || '',
                variant: 'datetime-full',
              }),
            },
          })}
          <Anchor href={source.url}>{source.key}</Anchor>
        </Text>
      )}
    </Card>
  )
}
